<template>
  <div :id="ip"
       style="width: 100%;height: 300px;background:white;">

  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'TempCharts',
  props: ['ip'],
  data () {
    return {
      tempList: [['2000-06-05', 116], ['2000-06-06', 129], ['2000-06-07', 135], ['2000-06-08', 86], ['2000-06-09', 73], ['2000-06-10', 85], ['2000-06-11', 73], ['2000-06-12', 68], ['2000-06-13', 92], ['2000-06-14', 130], ['2000-06-15', 245], ['2000-06-16', 139], ['2000-06-17', 115], ['2000-06-18', 111], ['2000-06-19', 309], ['2000-06-20', 206], ['2000-06-21', 137], ['2000-06-22', 128], ['2000-06-23', 85], ['2000-06-24', 94], ['2000-06-25', 71], ['2000-06-26', 106], ['2000-06-27', 84], ['2000-06-28', 93], ['2000-06-29', 85], ['2000-06-30', 73], ['2000-07-01', 83], ['2000-07-02', 125], ['2000-07-03', 107], ['2000-07-04', 82], ['2000-07-05', 44], ['2000-07-06', 72], ['2000-07-07', 106], ['2000-07-08', 107], ['2000-07-09', 66], ['2000-07-10', 91], ['2000-07-11', 92], ['2000-07-12', 113], ['2000-07-13', 107], ['2000-07-14', 131], ['2000-07-15', 111], ['2000-07-16', 64], ['2000-07-17', 69], ['2000-07-18', 88], ['2000-07-19', 77], ['2000-07-20', 83], ['2000-07-21', 111], ['2000-07-22', 57], ['2000-07-23', 55], ['2000-07-24', 60]],
      create_time: [],
      temp: [],
      myChart: {},
      option: {
        visualMap: {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 20,
          max: 120
        },
        title: {
          left: 'center',
          text: '温度监测 '
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          // data: this.create_time
          data: []
        },
        yAxis: {},

        series: {
          type: 'line',
          showSymbol: false,
          // data: this.temp
          data: []
        }
      }
    }
  },
  methods: {
    initCharts () {
      this.myChart = echarts.init(document.getElementById(this.ip))
      // var data = this.tempList
      // var dateList = data.map(function (item) {
      //   return item[0]
      // })
      // var valueList = data.map(function (item) {
      //   return item[1]
      // })
      this.option.xAxis.data = this.create_time
      this.option.series.data = this.temp

      this.myChart.setOption(this.option)
    },
    async getTempList () {
      // const { data: res } = await this.$http.post('UserFan', { userIp: 'ip101311923' })
      const { data: res } = await this.$http.post('userFan', `userIp=${this.ip}`)

      this.tempList = res
      this.create_time = []
      this.temp = []
      for (const i in this.tempList) {
        this.create_time.push(this.tempList[i].create_time)
        this.temp.push(this.tempList[i].temp)
        // this.option.xAxis.data.push(this.tempList[i].create_time)
        // this.option.series.data.push(this.tempList[i].temp)
        // console.log(this.option.series.data)
      }
      // console.log(this.create_time)
      // console.log(typeof (this.tempList))
      this.option.xAxis.data = this.create_time
      this.option.series.data = this.temp

      this.myChart.setOption(this.option)
    },
    changeTemp () {

    }
  },
  mounted () {
    this.initCharts()
  },
  created () {
    this.getTempList()
    setInterval(this.getTempList, 2000)
  }
}
</script>

<style scoped>
</style>
